import React from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import SwitcherTabsItem from './types';

interface Props {
  tabs: SwitcherTabsItem[];
  activeTab: string;
  onClick: (id: string) => void;
}

const SwitcherTabs: React.FC<Props> = ({ tabs, activeTab, onClick }) => {
  const location = useLocation();

  const isActive = (id: string, path: string, rootMatch: boolean) => {
    const { pathname } = location;
    let pathMatch = pathname === `/${path}`;

    if (rootMatch) {
      pathMatch = pathname.includes(path);
    }

    return id === activeTab && pathMatch;
  };

  return (
    <div className='saved-entities saved-entities_switcher'>
      <ul className='saved-entities__list'>
        {tabs.map(({ id, text, path, rootMatch = false }) => (
          <li
            key={id}
            className={classNames(
              'saved-entities__item saved-entities__item_fixed',
              { 'saved-entities__item_active': isActive(id, path, rootMatch) }
            )}
            onClick={() => onClick(id)}>
            <span className='saved-entities__item-outer'>
              <span className='saved-entities__item-inner utils-overflow-dots'>
                {text}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SwitcherTabs;
